import { ScreeningSurveyAttributesSchema } from "@clipboard-health/contract-home-health-api";
import { z } from "zod";

export const EMR_OTHER_VALUE = "OTHER";

export const screeningSurveyFormSchema = ScreeningSurveyAttributesSchema.extend({
  emrSystems: z.array(z.string()).min(1),
  emrSystemsOther: z.string().optional(),
  languages: z.array(z.string()).min(1),
  specialtyCareExperience: z.array(z.string()).min(1),
  whyHealthcare: z.string().min(10),
}).superRefine((data, context) => {
  if (data.emrSystems.includes(EMR_OTHER_VALUE) && !data.emrSystemsOther?.trim()) {
    context.addIssue({
      code: z.ZodIssueCode.custom,
      path: ["emrSystemsOther"],
      message: "Please describe the other EMR system",
    });
  }
});

export type ScreeningSurveyFormData = z.infer<typeof screeningSurveyFormSchema>;
